import { render, staticRenderFns } from "./GroupSelect.vue?vue&type=template&id=5349cb2a&scoped=true"
import script from "./GroupSelect.vue?vue&type=script&lang=js"
export * from "./GroupSelect.vue?vue&type=script&lang=js"
import style0 from "./GroupSelect.vue?vue&type=style&index=0&id=5349cb2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5349cb2a",
  null
  
)

export default component.exports